import React from 'react';

import { Switch } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  switchRoot: {
    width: theme.spacing(6.125),
    height: theme.spacing(3.25),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    borderRadius: theme.shape.borderRadius * 10
  },
  switchTrack: {
    background: theme.palette.grey[300],
    opacity: 1
  },
  switchThumb: {
    width: theme.spacing(3),
    height: theme.spacing(3)
  },
  switchBase: {
    top: -2,
    left: -1,
    borderRadius: '50%',
    padding: theme.spacing(0.375),
    color: theme.palette.common.white,
    '&.Mui-checked': {
      transform: `translateX(${theme.spacing(2.125)}px)`,
      color: theme.palette.common.white,
      '&:before': {
        content: '"I" !important',
        color: 'white',
        fontSize: theme.spacing(1.625),
        marginLeft: theme.spacing(-0.75),
        marginRight: theme.spacing(0.75)
      },
      '&:after': {
        content: 'none !important'
      }
    },
    '&:before': {
      content: 'none !important'
    },
    '&:after': {
      content: '"O" !important',
      color: 'white',
      fontSize: theme.spacing(1.625),
      marginLeft: theme.spacing(0.375)
    }
  },
  switchPrimary: {
    '&.Mui-checked + .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.primary.main
    }
  }
}));

const Toggle = ({ disabled, checked, onChange }: { disabled?: boolean, checked: boolean, onChange: (value: boolean) => void }) => {
  const classes = useStyles();
  const handleClick = () => {
    if (disabled) {
      return;
    }

    if (typeof onChange === 'function') {
      onChange(!checked);
    }
  };

  return (
    <Switch
      checked={checked}
      disabled={disabled}
      onChange={handleClick}
      inputProps={{ 'aria-label': 'controlled' }}
      color='primary'
      classes={{
        root: classes.switchRoot,
        track: classes.switchTrack,
        switchBase: classes.switchBase,
        thumb: classes.switchThumb,
        colorPrimary: classes.switchPrimary
      }}
    />
  );
};

export default Toggle;
